<div class="export-epg-screen-container">
  <div class="export-epg-screen">
    <h1>Clean Scheduler</h1>
    <h2>Please select date and time range for playlist to remove</h2>

    <div class="date-picker-epg-container">
      <label class="epg-option"> SELECT DATE TIME RANGE: </label>
      <div class="date-picker-epg-content">
        <label class="epg-option-inline">From: </label>
        <dateinput
          [(current)]="startDate"
          (currentChange)="changeStartDate($event)"
          [noTimePicker]="false"
        ></dateinput>
        <label class="epg-option-inline">To: </label>
        <dateinput
          [(current)]="endDate"
          (currentChange)="changeEndDate($event)"
          [noTimePicker]="false"
        ></dateinput>
      </div>
    </div>
    <a class="btn btn-export" (click)="deletePlaylist()" download
      >Delete Playlist</a
    >
  </div>
</div>
